import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as styleHelpersStyles } from '../../../assets/style-helpers.scss';

export const templateLicenseTrialSubForm = document.createElement('template');

templateLicenseTrialSubForm.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styleHelpersStyles}</style>
  <style>${styles}</style>

  <div id='wrapper'>
    <gz-title fontSize='11' fontWeight='600' class='title' id='product-details-title'></gz-title>
    <gz-text class='subtitle mt-2' fontSize="14" id='product-details-subtitle'></gz-text>

    <section id='activated-modules'>
      <gz-checkbox label='' id='elite-checkbox' disabled checked></gz-checkbox>
      <span class='module-info-text' id='elite-module-info-text'>
        <span id='elite-info-text'></span>
        <gz-link type='underline' color='primary' id='elite-link'></gz-link>
      </span>

      <gz-checkbox label='' id='office-security-pack-checkbox' disabled checked></gz-checkbox>
      <span class='module-info-text' id='office-security-pack-module-info-text'>
        <span id='office-security-pack-info-text'></span>
        <gz-link type='underline' color='primary' id='office-security-pack-link'></gz-link>
      </span>

      <gz-checkbox label='' id='atd-checkbox' disabled checked></gz-checkbox>
      <span class='module-info-text' id='atd-module-info-text'>
        <span id='atd-info-text'></span>
        <gz-link type='underline' color='primary' id='atd-link'></gz-link>
      </span>

      <gz-checkbox label='' id='full-disk-encryption-checkbox' disabled checked></gz-checkbox>
      <span class='module-info-text'>
        <span id='full-disk-encryption-info-text'></span>
        <gz-link type='underline' color='primary' id='full-disk-encryption-link'></gz-link>
      </span>

      <gz-checkbox label='' id='patch-management-checkbox' disabled checked></gz-checkbox>
      <span class='module-info-text'>
        <span id='patch-management-info-text'></span>
        <gz-link type='underline' color='primary' id='patch-management-link'></gz-link>
      </span>

      <gz-checkbox label='' id='security-for-storage-checkbox' disabled checked></gz-checkbox>
      <span class='module-info-text'>
        <span id='security-for-storage-info-text'></span>
        <gz-link type='underline' color='primary' id='security-for-storage-link'></gz-link>
      </span>

      <gz-checkbox label='' id='email-security-checkbox' disabled checked></gz-checkbox>
      <span class='module-info-text'>
        <span id='email-security-info-text'></span>
        <gz-link type='underline' color='primary' id='email-security-link'></gz-link>
      </span>

      <gz-checkbox label='' id='mobile-security-checkbox' disabled checked></gz-checkbox>
      <span class='module-info-text'>
        <span id='mobile-security-info-text'></span>
        <gz-link type='underline' color='primary' id='mobile-security-link'></gz-link>
      </span>
    </section>
  </div>
`;
